jQuery(function ($) {
  var smoothScrolling;

  $.SmoothScrolling = function () {
  };

  $.SmoothScrolling.prototype = {

    /**
     * Defines padding from element to last point of element
     * @static
     */
    padding: 20,

    /**
     * Defines the local link elements on the current view
     * @static
     */
    localAnchorElement: $('a[href*="#"]:not([href="#"])'),

    /**
     * @method init
     * @desc initialize this module depending on the client
     */
    init: function () {
      this.localAnchor();
      this.externalAnchor();
    },


    /**
     * @method localAnchor
     * @desc handle local anchor (click on link with jump mark)
     */
    localAnchor: function () {
      var parent = this;

      parent.localAnchorElement.click(function (event) {
        var target = $(this.hash);

        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
          if (/^[A-Za-z][A-Za-z0-9\-_:\.]*$/.test(this.hash.slice(1))) {

            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            if (target.length && !this.hasAttribute('data-toggle')) {
              parent.doScrolling(target);
            }

          }
          event.preventDefault();
        }
      });
    },

    /**
     * @method externalAnchor
     * @desc handle external anchor (direct to link via url parameter)
     */
    externalAnchor: function () {
      var parent = this;
      var urlHash = window.location.href.split("#")[1];
      var $scrollElement;

      if (urlHash && /^[A-Za-z][A-Za-z0-9\-_:\.]*$/.test(urlHash)) {
        // Get Scroll element
        $scrollElement = $('.' + urlHash + ', #' + urlHash + ',[name=' + urlHash + ']');

        if ($scrollElement.length) {
          parent.doScrolling($scrollElement);
        }
      }
    },

    /**
     * @method doScrolling
     * @desc scroll to spezific element
     */
    doScrolling: function (scrollToElement) {
      var parent = this;
      var currentTop = $(document).scrollTop();
      var scrollpixel = (scrollToElement.first().offset().top - currentTop);
      var scrollPosition;
      var $wpAdminBar = $('#wpadminbar');

      if (scrollpixel < 0) {
        scrollpixel *= -1;
      }

      if (scrollpixel * 0.59 > 2000) {
        scrollpixel = 3389;
      }

      $('html,body').stop().animate({
        scrollTop: scrollToElement.first().offset().top - 100
      }, {
        duration: scrollpixel * 0.59,
        step: function (now, fx) {
          scrollPosition = scrollToElement.first().offset().top - $('.site-header').height() - parent.padding;

          // CHeck if Wordpress Admin Bar exist
          if ($wpAdminBar.length) {
            scrollPosition -= $wpAdminBar.height();
          }

          if (scrollPosition !== fx.end) {
            fx.end = scrollPosition;
          }
        }
      });
    }
  };

  smoothScrolling = new $.SmoothScrolling();
  smoothScrolling.init();
});
